/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppRoute { 
    path?: string;
    componentKey?: string;
    redirectTo?: string;
    data?: { [key: string]: any; };
    canActivate?: Array<string>;
    resolve?: { [key: string]: string; };
    runGuardsAndResolvers?: string;
    children?: Array<AppRoute>;
}

